import React from 'react';
import { Pagination, List, Edit, Create, Filter, DatagridConfigurable, TextField, TextInput, SimpleForm, ReferenceInput, SelectInput } from 'react-admin';
import { stripedDataGridSx } from './styles/dataGridStyles';
import Empty from './components/Empty';
import PeopleIcon from '@mui/icons-material/People';

const CustomerFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Customer" source="id" reference="customers" allowEmpty>
            <SelectInput optionText="Customer" />
        </ReferenceInput>
    </Filter>
);

const CustomerPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const CustomerList = props => {
    return (
        <List
            filters={<CustomerFilter />}
            sort={{ field: 'Customer', order: 'ASC' }}
            perPage={100}
            pagination={<CustomerPagination />}
            bulkActionButtons={false}
            empty={<Empty icon={PeopleIcon} title="No customers yet" description="Add your first customer to get started" />}
            {...props}
        >
            <DatagridConfigurable
                rowClick="edit"
                sx={stripedDataGridSx}
            >
                <TextField label="Customer" source="Customer" />
                <TextField label="Street Address" source="Billing_Street_Address" />
                <TextField label="City" source="Billing_City" />
                <TextField label="State" source="Billing_State" />
                <TextField label="Zip" source="Billing_Zipcode" />
                <TextField label="First Name" source="Contact_First_Name" />
                <TextField label="Last Name" source="Contact_Last_Name" />
                <TextField label="Phone" source="Contact_Phone" />
                <TextField label="Email" source="Contact_Email" />
            </DatagridConfigurable>
        </List>
    )
}

export const CustomerEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm redirect="list">
            <TextInput disabled label="ID" source="id" />
            <TextInput label="Customer" source="Customer" />
            <TextInput label="Category" source="Category" />
            <TextInput label="Type" source="Type" />
            <TextInput label="Customer Type" source="Customer_Type" />
            <TextInput label="Billing Street Address" source="Billing_Street_Address" />
            <TextInput label="Billing City" source="Billing_City" />
            <TextInput label="Billing State" source="Billing_State" />
            <TextInput label="Billing Zipcode" source="Billing_Zipcode" />
            <TextInput label="Contact First Name" source="Contact_First_Name" />
            <TextInput label="Contact Last Name" source="Contact_Last_Name" />
            <TextInput label="Contact Phone" source="Contact_Phone" />
            <TextInput label="Contact Fax" source="Contact_Fax" />
            <TextInput label="Contact Email" source="Contact_Email" />
        </SimpleForm>
    </Edit>
);

export const CustomerCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput label="Customer" source="Customer" />
            <TextInput label="Category" source="Category" />
            <TextInput label="Type" source="Type" />
            <TextInput label="Customer Type" source="Customer_Type" />
            <TextInput label="Billing Street Address" source="Billing_Street_Address" />
            <TextInput label="Billing City" source="Billing_City" />
            <TextInput label="Billing State" source="Billing_State" />
            <TextInput label="Billing Zipcode" source="Billing_Zipcode" />
            <TextInput label="Contact First Name" source="Contact_First_Name" />
            <TextInput label="Contact Last Name" source="Contact_Last_Name" />
            <TextInput label="Contact Phone" source="Contact_Phone" />
            <TextInput label="Contact Fax" source="Contact_Fax" />
            <TextInput label="Contact Email" source="Contact_Email" />
        </SimpleForm>
    </Create>
);
